import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function Copyright(props: any) {
  const localUiVersion = process.env.REACT_APP_VERSION || 'dev';
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.inosio.com/">
        Inosio
      </Link>{' '}
      {new Date().getFullYear()} v{localUiVersion}
      {'.'}
    </Typography>
  );
}
